import { render } from "./NavigationItems.vue?vue&type=template&id=52882566"
import script from "./NavigationItems.vue?vue&type=script&lang=js"
export * from "./NavigationItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__